import { render, staticRenderFns } from "./UcRentalValidityCard.yaml?vue&type=template&id=0830ed18&component"
import script from "./UcRentalValidityCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcRentalValidityCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports